import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';

export const SKIN_TYPES = [
  { value: 'oily', label: 'Oily' },
  { value: 'dry', label: 'Dry' },
  { value: 'combination', label: 'Combination' },
  { value: 'normal', label: 'Normal' },
  { value: 'sensitive', label: 'Sensitive' },
];

export const CONCERNS = [
  { value: 'dullness', label: 'Dullness' },
  { value: 'acne', label: 'Acne' },
  { value: 'fine-lines', label: 'Fine lines' },
  { value: 'pores', label: 'Pores' },
  { value: 'hyperpigmentation', label: 'Dark spots' },
  { value: 'redness', label: 'Redness' },
  { value: 'dehydration', label: 'Dehydration' },
  { value: 'puffiness', label: 'Puffiness' },
];

export const FilterChips = ({ value, onChange, options, label, testId }) => (
  <div data-testid={testId} className="min-w-0">
    <p className="text-[11px] uppercase tracking-[0.18em] text-muted-foreground mb-2">{label}</p>
    <ToggleGroup
      type="single"
      value={value || ''}
      onValueChange={(v) => onChange(v || null)}
      className="flex flex-wrap gap-2 justify-start"
    >
      {options.map((o) => (
        <ToggleGroupItem
          key={o.value}
          value={o.value}
          className="rounded-full px-3 py-1.5 h-auto text-[12px] tracking-[0.02em] border border-border/80 bg-background hover:bg-secondary data-[state=on]:bg-accent data-[state=on]:text-foreground data-[state=on]:border-rose-soft"
          data-testid={`${testId}-option-${o.value}`}
        >
          {o.label}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  </div>
);

export default FilterChips;
